
import helper from '../helper'

const _h = ( obj ) => {
    return helper.creatObject( obj )
}

const footerAnimation = () => {

    // const elements = 
    const scroll = document.querySelectorAll('.hb-scrolle-ffect')
    if (!scroll) return

    scroll.forEach( (element) =>{
        
        if (element !== undefined) {
            const classes = element.classList
            
            if (classes) {
                let scrollEventFrom = {}
                let scrollEventTo = {}
                let run = false
                let duration = '5%'
                let indicator = '95%'


                if (classes.contains('hb-sticky') || classes.contains('hb-parallax')) {
                    // const wpadminbar = document.querySelector('#wpadminbar')
                    // const wpadminbarHeight = wpadminbar ? wpadminbar.offsetHeight : 0
                    let elementHeight = element.offsetHeight

                    // if ( element.getAttribute('id') !== 'hb-footer' ) {
                    //     elementHeight = elementHeight * -1
                    // }

                    if (classes.contains('hb-sticky')) {
                        scrollEventFrom = {
                            translateY: elementHeight*-1,
                            ...scrollEventFrom
                        };
                        scrollEventTo = {
                            translateY: 0,
                            ...scrollEventTo
                        };
                        run = true;
                    } else if (classes.contains('hb-parallax')) {
                        scrollEventFrom = {
                            translateY: (elementHeight/2) * -1,
                            ...scrollEventFrom
                        };
                        scrollEventTo = {
                            translateY: elementHeight/2,
                            ...scrollEventTo
                        };
                        run = true;
                    }

                    //  if (classes.contains('hb-sticky')) {
                    //     scrollEventFrom = {
                    //         translateY: elementHeight * -1,
                    //         ...scrollEventFrom
                    //     };
                    //     scrollEventTo = {
                    //         translateY: elementHeight,
                    //         ...scrollEventTo
                    //     };
                    //     run = true;
                    // } else if (classes.contains('hb-parallax')) {
                    //     scrollEventFrom = {
                    //         translateY: (elementHeight/2) * -1,
                    //         ...scrollEventFrom
                    //     };
                    //     scrollEventTo = {
                    //         translateY: elementHeight/2,
                    //         ...scrollEventTo
                    //     };
                    //     run = true;
                    // }


                    _h( element.parentNode ).css({
                        height: elementHeight+'px',
                    //     // position: 'relative',
                        overflow: 'hidden'
                    });
                }

                // hb-sticky, hb-parallax, hb-opacity, hb-scaleIn, hb-scaleOut
                if (classes.contains('hb-opacity')) {
                    scrollEventFrom = {
                        opacity: 0,
                        ...scrollEventFrom
                    };
                    scrollEventTo = {
                        opacity: 1,
                        ...scrollEventTo
                    };
                    run = true;
                }
                if (classes.contains('hb-scaleIn')) {
                    scrollEventFrom = {
                        scale: 0,
                        ...scrollEventFrom
                    };
                    scrollEventTo = {
                        scale: 1,
                        ...scrollEventTo
                    };
                    run = true;
                } else if (classes.contains('hb-scaleOut')) {
                    scrollEventFrom = {
                        scale: 1.5,
                        ...scrollEventFrom
                    };
                    scrollEventTo = {
                        scale: 1,
                        ...scrollEventTo
                    };
                    run = true;
                }

                run && (() => {

                    let superEventsScroll = new superEvents( element );

                    superEventsScroll.scroll({
                        indicator: indicator,
                        duration: duration,
                        listener: 'load',
                        // debug: true
                    })
                    .fromTo(
                        scrollEventFrom,
                        scrollEventTo
                    )
                    // .easing('easeInOutBack')
                })()
            }

        }
    })
}

export default footerAnimation;
